
import request from "@/utils/request";

// 查询导航栏数据
export function getNavigation() {
  return request({
    url: '/external/getNavigation',
    method: 'post',
  })
}

// 查询导航栏数据
export function queryHomeSubmitData() {
  return request({
    url: '/external/queryHomeSubmitData',
    method: 'post',
  })
}

// 查询首页顶部内容数据
export function queryHomeTitleInfo() {
  return request({
    url: '/external/queryHomeTitleInfo',
    method: 'post',
  })
}

//查询新闻内容数据
export function queryNews(queryParams) {
  var i = typeof queryParams == 'undefined'?'':queryParams
  return request({
    url: '/external/queryNews'+i,
    method: 'post',
  })
}

//查询产品内容数据
export function queryProduct(queryParams) {
  return request({
    url: '/external/queryProduct'+queryParams,
    method: 'post',
  })
}

//查询科技内容数据
export function querySupport() {
  return request({
    url: '/external/querySupport',
    method: 'post',
  })
}

//查询企业介绍内容数据
export function queryIntroduce() {
  return request({
    url: '/external/queryIntroduce',
    method: 'post',
  })
}

//查询发展历程内容数据
export function queryCoures() {
  return request({
    url: '/external/queryCoures',
    method: 'post',
  })
}

//查询发展历程内容数据
export function queryPlatform(queryParams) {
  return request({
    url: '/external/queryPlatform'+queryParams,
    method: 'post',
  })
}

//查询专利内容数据
export function queryPatent(queryParams) {
  return request({
    url: '/external/queryPatent'+queryParams,
    method: 'post',
  })
}


// WEBPACK FOOTER //
// ./src/utils/gw.js